import React, { useEffect, useState } from "react";
import api from "../../lib/api";
import { toast } from "sonner";

const FIELDS = [
    { key: "whatsappNumber", label: "WhatsApp Number (no + sign, e.g., 919999999999)" },
    { key: "announcementText", label: "Announcement Bar Text" },
    { key: "defaultWhatsappTemplate", label: "Default WhatsApp Message Template (use {product_name}, {price})" },
    { key: "instagramUrl", label: "Instagram URL" },
    { key: "facebookUrl", label: "Facebook URL" },
    { key: "pinterestUrl", label: "Pinterest URL" },
    { key: "ga4Id", label: "GA4 Measurement ID" },
    { key: "shippingPolicy", label: "Shipping Policy" },
    { key: "returnPolicy", label: "Return Policy" },
];

export default function AdminSettings() {
    const [s, setS] = useState(null);
    useEffect(() => { document.title = "Admin Settings | Loomara"; api.get("/settings").then(({ data }) => setS(data)); }, []);

    const save = async () => {
        try {
            const payload = {};
            FIELDS.forEach((f) => { payload[f.key] = s[f.key] || ""; });
            const { data } = await api.put("/settings", payload);
            setS(data);
            toast("Settings saved");
        } catch (e) { toast(e.response?.data?.detail || "Save failed"); }
    };

    if (!s) return <p>Loading…</p>;

    return (
        <div className="max-w-2xl" data-testid="admin-settings-page">
            <p className="eyebrow">Store</p>
            <h1 className="font-serif text-4xl text-ink-900 mt-2 mb-8">Settings</h1>

            <div className="card-soft p-8 space-y-4">
                {FIELDS.map((f) => (
                    <div key={f.key}>
                        <label className="block text-[11px] uppercase tracking-[0.22em] text-ink-500 mb-1.5">{f.label}</label>
                        {f.key.includes("Policy") || f.key.includes("Template") ? (
                            <textarea rows={3} value={s[f.key] || ""} onChange={(e) => setS({ ...s, [f.key]: e.target.value })} className="w-full bg-ivory-100 rounded-xl px-4 py-2.5 text-sm border border-sage-300/30 focus:outline-none focus:ring-2 focus:ring-sage-300" data-testid={`setting-${f.key}`} />
                        ) : (
                            <input value={s[f.key] || ""} onChange={(e) => setS({ ...s, [f.key]: e.target.value })} className="w-full bg-ivory-100 rounded-xl px-4 py-2.5 text-sm border border-sage-300/30 focus:outline-none focus:ring-2 focus:ring-sage-300" data-testid={`setting-${f.key}`} />
                        )}
                    </div>
                ))}
                <div className="flex justify-end mt-2">
                    <button onClick={save} className="btn-primary" data-testid="settings-save">Save Settings</button>
                </div>
            </div>
        </div>
    );
}
